/* eslint-disable no-unused-vars */
import logo from "./logo.svg";
import React, { useEffect, useState, useRef } from "react";
import "./App.css";

//a list of all the codenames words
//vectors for the codenames words
//a list of the most common words, redundant with vecCache
//vectors for the most common 1500 words
import axios from "axios";
import { FaTwitter } from "react-icons/fa";
import codenames400 from "./codenames400.json";

let urlencode = require("urlencode");

// import largeVecs from './20kvecs'

const capFirstLet = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
const duration = 500;
const delay = 100;
const animStr = (i) => `fadeIn ${duration}ms ease-out ${delay * i}ms forwards`;

const instructions = [
  "Get the computer to guess all the purple words on the board",
  "You do this by giving the computer hints",
  "Each hint is a single word and a number",
  "Example: Orange 2",
  "With this hint, the computer would guess the two words on the board closest in meaning to orange",
  "Keep giving the computer hints until all purple words have been guessed!",
  "You start with a score of 0 and want to keep your score as low as possible (like golf)",
  "Each hint you give adds 1 to your score",
  "There is one word on a dark gray background. If the computer guesses this word, you lose instantly",
  "Tan words are distractions. When the computer guesses a tan word, it stops guessing until the next hint",
  "After you give a hint, you can see what the computer is thinking on the left",
  "If you feel ambitious, every puzzle can be solved with a single hint. Try and find the magic word!",
  "Good luck!",
];

function App() {
  const [board, setBoard] = useState([]);
  const [history, setHistory] = useState([]);
  const [brainList, setBrainList] = useState([]);
  const [seed, setSeed] = useState(
    Math.trunc((Date.now() - 8 * 60 * 60 * 1000) / (1000 * 60 * 60 * 24))
  );
  const [hintWordInput, setHintWordInput] = useState("");
  const [hintNumInput, setHintNumInput] = useState("");
  const [currHint, setCurrHint] = useState({ word: "", num: "" });
  const inputRef = useRef([]);
  const [animationTarget, setAnimationTarget] = useState([0, 0, "correct"]);
  const [renderGuessAnimation, setRenderGuessAnimation] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);
  const [showEndModal, setshowEndModal] = useState("");
  const [errorText, setErrorText] = useState(
    window.innerWidth > 700 ? "" : "Best on a Computer :)"
  );
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const dotp = (x, y) => {
    const dotp_sum = (a, b) => {
      return a + b;
    };
    const dotp_times = (a, i) => {
      return x[i] * y[i];
    };
    return x.map(dotp_times).reduce(dotp_sum, 0);
  };

  const getFirebaseVector = async (word) => {
    var config = {
      headers: {
        // Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    return await axios
      .post(
        "https://us-central1-codebreakle.cloudfunctions.net/getBetterVector",
        // "http://localhost:5001/codebreakle/us-central1/getBetterVector",
        {
          word: word.toLowerCase(),
        },
        config
      )
      // .then(response => doneGenerating(response))
      .catch((error) => console.log(error));
  };

  const getGpt3Solution = async (board, guess, num) => {
    console.log("starting getting gpt3 solution");
    var config = {
      headers: {
        // Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      },
    };
    return await axios
      .post(
        "http://localhost:5001/codebreakle/us-central1/getBoardGuesses",
        {
          board,
          guess,
          num,
        },
        config
      )
      // .then(response => doneGenerating(response))
      .catch((error) => console.log(error));
  };

  const cosineSimilarity = (A, B) => {
    var similarity =
      dotp(A, B) / (Math.sqrt(dotp(A, A)) * Math.sqrt(dotp(B, B)));
    return similarity;
  };

  const shuffle = (array, seed) => {
    var m = array.length,
      t,
      i;

    while (m) {
      // Pick a remaining element…
      i = Math.floor(random(seed) * m--);
      t = array[m];
      array[m] = array[i];
      array[i] = t;
      ++seed;
    }

    return array;
  };

  const random = (seed) => {
    var x = Math.sin(seed++) * 10000;
    return x - Math.floor(x);
  };

  React.useLayoutEffect(() => {
    function updatePosition() {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
      console.log(window.innerHeight, window.innerWidth);
      // setSearchResultTop(
      //   searchBarReference.current.getBoundingClientRect().bottom
      // )
      setAnimationTarget([
        inputRef?.current?.[0]?.getBoundingClientRect()?.top,
        inputRef?.current?.[0]?.getBoundingClientRect()?.left,
        animationTarget[2],
      ]);
      //?.[0]?.getBoundingClientRect())
    }
    window.addEventListener("resize", updatePosition);
    updatePosition();
    return () => window.removeEventListener("resize", updatePosition);
  }, []);

  useEffect(() => {
    console.log(height, width);
    // console.log(codenamesWords.words); // "some sample text"
    // console.log(vectors)
    setTimeout(() => setShowInstructions(true), 1000);
    initBoard();
  }, []);

  const restartPuzzle = () => {
    initBoard();
    setHistory([]);
    setBrainList([]);
    setCurrHint({ word: "", num: "" });
    setAnimationTarget([0, 0, "correct"]);
    setRenderGuessAnimation(false);
    setshowEndModal("");
  };

  const shareOnTwitter = () => {
    let url =
      "https://twitter.com/intent/tweet?text=" +
      urlencode(
        `I scored ${history.length} on today's Codebreakle!\n\nCan you beat me? https://john.fun/codebreakle`
      );
    window.open(url, "_blank");
  };

  const initBoard = () => {
    //get random word vector
    const magicWord = shuffle(Object.keys(codenames400), seed)[0];
    console.log(magicWord);
    const magicVector = codenames400[magicWord];
    const codenamesWords = Object.keys(codenames400);
    let ranking = [];
    for (let i = 0; i < codenamesWords.length; i += 1) {
      const word = codenamesWords[i];
      const vec = codenames400[word];
      const sim = cosineSimilarity(magicVector, vec);
      ranking.push([word, sim]);
    }
    const neutralWorlds = [];
    const allWords = [];
    ranking = ranking.sort((a, b) => b[1] - a[1]);
    const purpleWords = [];
    let tempBoard = [];

    const easier = shuffle(ranking.slice(6, 50), seed);
    for (let i = 0; i < 8; i += 1) {
      purpleWords.push(easier[i][0]);

      tempBoard.push({ word: easier[i][0], type: "purple" });
    }
    const remainder = shuffle(ranking.slice(51), seed);
    for (let i = 8; i < 24; i += 1) {
      tempBoard.push({ word: remainder[i][0], type: "peach" });
      neutralWorlds.push(remainder[i][0]);
    }
    const assassin = remainder[26][0];
    tempBoard.push({ word: remainder[26][0], type: "black" });
    tempBoard = shuffle(tempBoard, seed);
    setBoard(tempBoard);

    //find the cosine similarity between it and all 400 codenames words
    //sort the cosine similarity and take the top 8 words
    //randomize the remainder and take 16
    //take one as the assassin
    //concat all into a list

    for (let i = 0; i < purpleWords.length; i += 1) {
      allWords.push({ word: purpleWords[i], type: "purple" });
    }
    const correctMap = {};
  };

  const animateGuesses = (displayActions, tempBoard) => {
    if (displayActions.length === 0) return;
    // let newBoard = board
    for (let j = 0; j < 25; j += 1) {
      const boardWord = board[j].word;
      const actionWord = displayActions[0].word;
      if (boardWord === actionWord) {
        setAnimationTarget([
          inputRef?.current?.[j]?.getBoundingClientRect()?.top,
          inputRef?.current?.[j]?.getBoundingClientRect()?.left,
          displayActions[0].guessType,
        ]);
        setRenderGuessAnimation(true);
        // eslint-disable-next-line no-loop-func
        setTimeout(() => {
          // setBrainList(tempBrainList.slice(0, 13))
          setRenderGuessAnimation(false);
          let newBoard = [
            ...tempBoard.slice(0, j),
            { word: boardWord, type: displayActions[0].guessType },
            ...tempBoard.slice(j + 1),
          ];
          setBoard(newBoard);
          animateGuesses(displayActions.slice(1), newBoard);
        }, 1200);
      }
    }
  };

  const submitHint = async () => {
    if (hintWordInput === "" || hintNumInput === "") {
      setErrorText("Enter a valid word and number");
      return;
    }
    for (let i = 0; i < board.length; i += 1) {
      if (
        board[i].word.toLowerCase() === hintWordInput.toLocaleLowerCase() &&
        board[i].type === "purple"
      ) {
        setErrorText("You can't use words on the board as hints");
        return;
      }
    }
    for (let i = 0; i < history.length; i += 1) {
      if (history[i].word.toLowerCase() === hintWordInput.toLocaleLowerCase()) {
        setErrorText("You can't use the same word twice");
        return;
      }
    }
    let correctGuesses = 0;
    for (let i = 0; i < history.length; i += 1) {
      if (history[i].results[0].guessType === "correctGlyph") {
        correctGuesses += history[i].results[0].num;
      }
    }
    if (parseInt(hintNumInput) + correctGuesses > 8) {
      setErrorText("There aren't that many words left to guess");
      return;
    }
    let hintVec = undefined;
    if (hintWordInput in codenames400) {
      hintVec = codenames400[hintWordInput];
    } else {
      let theVec = await getFirebaseVector(hintWordInput.toLocaleLowerCase());
      if (theVec?.data) {
        hintVec = Array.from(theVec?.data);
      } else {
        setErrorText("I don't know that word");
        return;
      }
    }
    setErrorText("");
    setCurrHint({ word: hintWordInput, num: hintNumInput });
    let tempBrainList = [];
    for (let i = 0; i < 25; i += 1) {
      let item = board[i];
      if (
        item.type === "purple" ||
        item.type === "peach" ||
        item.type === "black"
      ) {
        const codenamesVec = codenames400[item.word];
        tempBrainList.push({
          word: item.word,
          sim: cosineSimilarity(hintVec, codenamesVec) * 100,
          color: item.type + "bar",
        });
      }
    }
    tempBrainList = tempBrainList.sort((a, b) => b.sim - a.sim);
    let low = tempBrainList[Math.min(14, tempBrainList.length - 1)].sim;
    let high = tempBrainList[0].sim;
    let diff = 80.0 / (high - low);
    tempBrainList = tempBrainList.map((obj) => {
      return {
        ...obj,
        sim: Math.trunc((obj.sim - low) * diff + 10 - Math.random() * 7),
      };
    });

    setBrainList([]);

    let tempResults = [];
    let displayActions = [];
    for (let i = 0; i < parseInt(hintNumInput); i += 1) {
      if (tempBrainList[i].color === "purplebar") {
        if (tempResults.length === 0) {
          tempResults.push({ guessType: "correctGlyph", num: 1 });
          displayActions.push({
            word: tempBrainList[i].word,
            guessType: "correct",
          });
        } else {
          tempResults[0]["num"] += 1;
          displayActions.push({
            word: tempBrainList[i].word,
            guessType: "correct",
          });
        }
      } else if (tempBrainList[i].color === "peachbar") {
        tempResults.push({ guessType: "neutralGlyph", num: 1 });
        displayActions.push({
          word: tempBrainList[i].word,
          guessType: "incorrect",
        });
        break;
      } else if (tempBrainList[i].color === "blackbar") {
        tempResults.push({ guessType: "deadGlyph", num: 1 });
        displayActions.push({
          word: tempBrainList[i].word,
          guessType: "dead",
        });
        break;
      }
      // {
      //   results: [
      //     { guessType: 'correctGlyph', num: 8 },
      //     { guessType: 'neutralGlyph', num: 1 }
      //   ],
      //   word: 'Help',
      //   target: 9
      // },
    }
    // let newBoard = board
    // for (let i = 0; i < displayActions.length; i += 1) {
    //   for (let j = 0; j < 25; j += 1) {
    //     const boardWord = board[j].word
    //     const actionWord = displayActions[i].word
    //     if (boardWord === actionWord) {
    //       console.log('edit board')
    //       newBoard = [
    //         ...newBoard.slice(0, j),
    //         { word: boardWord, type: displayActions[i].guessType },
    //         ...newBoard.slice(j + 1)
    //       ]
    //     }
    //   }
    // }
    // setBoard(newBoard)
    // console.log("wait for return");

    //uncomment the block below to enable GPT3 functionality
    /*
      it turns out it's not that good sadly
      It takes around $0.10 to run each query as well
      There are a few bugs (end condition is not triggered correctly)
      A guess for 2 exactly shows two green thumbs up instead of 1
    */
    // let gptOutput = await getGpt3Solution(
    //   board,
    //   hintWordInput,
    //   parseInt(hintNumInput)
    // );
    // let data = gptOutput.data;
    // // console.log("returned");
    // // console.log(gptOutput);
    // tempResults = data["tempResults"];
    // displayActions = data["displayActions"];
    // setErrorText(data["reason"]);
    // console.log(data);

    setTimeout(() => {
      let correctGuesses =
        tempResults?.[0]?.guessType === "correctGlyph"
          ? tempResults?.[0]?.num
          : 0;
      for (let i = 0; i < history.length; i += 1) {
        if (history[i].results[0].guessType === "correctGlyph") {
          correctGuesses += history[i].results[0].num;
        }
      }
      setBrainList(tempBrainList.slice(0, 13));
      setHistory([...history, newHistoryItem]);
      if (displayActions[displayActions.length - 1].guessType === "dead") {
        setTimeout(() => {
          setshowEndModal("lose");
        }, 1000);
      } else if (correctGuesses === 8) {
        setTimeout(() => {
          setshowEndModal("win");
        }, 1000);
      } else if (history.length >= 9) {
        setTimeout(() => {
          setshowEndModal("timeout");
        }, 1000);
      }
    }, displayActions.length * 1200);
    animateGuesses(displayActions, board);
    const newHistoryItem = {
      results: tempResults,
      word: hintWordInput,
      target: hintNumInput,
    };
    setHintWordInput("");
    setHintNumInput("");
  };

  return (
    <div className="App">
      <header className="App-header"></header>
      <body>
        <div className="topContainer">
          <div className="title">CODEBREAKLE</div>
        </div>
        <div className="middleContainer">
          <div className="leftColumn">
            {width > 1700 && (
              <>
                <div className="columnHeader">
                  {brainList.length > 0 ? capFirstLet(currHint?.word) : ""}
                </div>
                {brainList.map((item, i) => (
                  <RankingItem
                    word={item.word}
                    sim={item.sim}
                    max={brainList?.[0]?.sim ?? 100}
                    color={item.color}
                    style={{ opacity: 0, animation: animStr(i) }}
                  ></RankingItem>
                ))}
              </>
            )}
          </div>

          <div className="boardContainer">
            {board.map((item, idx) => (
              <Card
                type={item.type}
                text={item.word}
                passRef={(el) => (inputRef.current[idx] = el)}
              ></Card>
            ))}
          </div>
          <div className="rightColumn">
            {width > 1700 && (
              <>
                {history.length > 0 && (
                  <div className="columnHeader">History</div>
                )}

                {history.map((item) => (
                  <HistoryItem
                    word={item.word}
                    results={item.results}
                    target={item.target}
                  ></HistoryItem>
                ))}
              </>
            )}
          </div>
        </div>
        <div className="bottomContainer">
          <div className="inputContainer">
            <div className="hintInput">
              <form>
                <input
                  type="text"
                  className="inside"
                  placeholder={`Type your clue${width > 1000 ? " here" : ""}`}
                  onChange={(event) =>
                    setHintWordInput(event.target.value.trim())
                  }
                  onKeyPress={(e) => {
                    e.key === "Enter" && e.preventDefault();
                  }}
                  value={hintWordInput}
                />
              </form>
            </div>
            <div className="numberInput">
              <form>
                <input
                  type="text"
                  className="inside"
                  placeholder="#"
                  onChange={(event) => {
                    let newVal = event.target.value.replace(/\D/g, "");
                    newVal = newVal.replace(/0/g, "");
                    if (newVal.length > 1) {
                      newVal = newVal[0];
                    }
                    setHintNumInput(newVal);
                  }}
                  onKeyPress={(e) => {
                    e.key === "Enter" && e.preventDefault();
                  }}
                  value={hintNumInput}
                />
              </form>
            </div>
            <div className="submitButton divButton" onClick={submitHint}>
              Submit
            </div>
          </div>
          <div className="errorText">{errorText}</div>
        </div>
        {renderGuessAnimation && (
          <Card
            type={animationTarget[2]}
            text={"Testing"}
            style={{
              position: "absolute",
              top: `${animationTarget[0]}px`,
              left: `${animationTarget[1]}px`,
              margin: "0px",
              "z-index": 2,
              animation: `moveToSpot${
                Math.random() > 0.5 ? 2 : ""
              } 1200ms ease-out 0ms forwards`,
            }}
          ></Card>
        )}
        {showInstructions && (
          <>
            <div
              className="opacityLayer"
              onClick={() => setShowInstructions(false)}
            ></div>
            <div
              className="instructions"
              onClick={() => setShowInstructions(false)}
            >
              <div
                className="xButton divButton"
                onClick={() => setShowInstructions(false)}
              >
                x
              </div>
              <div className="instructionHeader">Instructions</div>
              <div className="instructionBody">
                {instructions.map((phrase) => (
                  <div className="instructionText">{phrase}</div>
                ))}
              </div>
            </div>
          </>
        )}
        <EndModal
          type={showEndModal}
          score={history.length}
          retryFunction={restartPuzzle}
          shareFunction={shareOnTwitter}
        ></EndModal>
      </body>
    </div>
  );
}

function Card(props) {
  return (
    <div
      className={`card ${props.type}`}
      ref={props?.passRef}
      style={props?.style}
    >
      <div className="half"></div>
      <div className="cardText">
        {props.type === "purple" ||
        props.type === "peach" ||
        props.type === "black"
          ? capFirstLet(props.text)
          : ""}
      </div>
    </div>
  );
}

function EndModal(props) {
  if (props.type === "") return null;
  return (
    <>
      <div className="opacityLayer"></div>
      <div className="endModalContainer">
        <div className="modalIconContainer">
          <div
            className={props.type === "win" ? "modalIconWin" : "modalIconLose"}
          ></div>
        </div>
        <div className="modalHeader">
          {props.type === "win" ? "You Win!" : "You Lose"}
        </div>
        <div className="modalText">
          {props.type === "win"
            ? `You finished with a score of ${props.score}\nCome back tomorrow for a new puzzle!`
            : props.type === "timeout"
            ? "You took too many guesses"
            : "You know you’re supposed to make the computer AVOID the death word right?"}
        </div>
        <div className="modalButtonContainer">
          <div
            className="modalRetryButton divButton"
            onClick={props.retryFunction}
          >
            Retry{props.type === "win" ? " today's puzzle" : ""}
          </div>
          {props.type === "win" && (
            <div
              className="twitterShareButton divButton"
              onClick={props.shareFunction}
            >
              <FaTwitter class="twitter" />
              Share
            </div>
          )}
        </div>
      </div>
    </>
  );
}

function HistoryItem(props) {
  return (
    <div className={`historyRectangle`}>
      <div className="historyText">
        {capFirstLet(props.word) + " " + props.target}
      </div>
      {props.results.map((guess) => (
        <>
          <div className={`glyph ${guess.guessType}`}></div>
          <div className="num">{guess.num}</div>
        </>
      ))}
    </div>
  );
}

function RankingItem(props) {
  return (
    <div className={`rankingItemContainer`} style={props.style}>
      <div className="rankingText">{capFirstLet(props.word)}</div>
      <div className="rankingGraphContainer">
        <div
          className={`rankingGraph ${props.color}`}
          style={{
            "flex-basis": `${Math.trunc((props.sim / props.max) * 80) + 20}%`,
          }}
        >
          {props.sim}%
        </div>
      </div>
    </div>
  );
}

export default App;
